/**
 * Mobile menu tools.
 */
function mobile_menu_tools() {
    /**
     * Finds and returns all focusable children of the supplied parent element.
     *
     * @param {*} el A parent element
     * @returns Focusable children of the parent element
     */
    function getFocusableChildren(el) {
        return el.querySelectorAll([
            'input',
            'select',
            'a[href]',
            'textarea',
            'button',
            '[tabindex]',
        ]);
    }

    /**
     * Checks if the supplied element is inside the mobile menu and returns a representative boolean value.
     *
     * @param {*} menu
     * @param {*} el   The element to examine
     * @returns        `true` if the element is inside the mobile menu, `false` otherwise
     */
    function isElementInsideMenu(menu, el) {
        // console.log('Checking if element is inside menu...');
        // console.log('el', el);
        // console.log('menu', menu);
        return menu.contains(el);
    }

    /**
     * Opens the menu.
     *
     * @param {*} toggles
     */
    function openMenu(toggles) {
        for (let i = 0; i < toggles.length; i++) {
            toggles[i].setAttribute('aria-expanded', 'true');
        }
        document.documentElement.classList.add('-is-active-menu');
    }

    /**
     * Closes the menu.
     *
     * @param {*} menu
     * @param {*} toggles
     * @param {*} animationDuration
     * @param {*} toggle            (Optional) The toggle that triggered the close
     */
    function closeMenu(menu, toggles, animationDuration = 200, toggle = false) {
        // console.log('Closing menu...');
        // console.log('toggle', toggle);

        for (let i = 0; i < toggles.length; i++) {
            toggles[i].setAttribute('aria-expanded', 'false');
        }

        if (
            toggle &&
            'classList' in toggle &&
            toggle.classList.contains('js-menu-toggle') &&
            !toggle.classList.contains('-can-open')
        ) {
            window.mobile_menu_tools.focusOpeningToggle(menu);
        }

        document.documentElement.classList.add('-is-closing-menu');
        setTimeout(() => {
            document.documentElement.classList.remove('-is-active-menu');
            document.documentElement.classList.remove('-is-closing-menu');
        }, animationDuration);
    }

    /**
     * Makes all focusable children of the supplied element close the mobile menu
     * on focus, provided that they aren't a mobile menu toggle or inside the mobile menu.
     *
     * This function may need to be reaplied if the DOM is manipulated using JavaScript.
     *
     * @param {*} el An element
     */
    function makeOutsideFocusCloseMenu(
        menu,
        toggles,
        el,
        animationDuration = 200
    ) {
        const children = getFocusableChildren(el);
        children.forEach((element) => {
            element.addEventListener('focus', (e) => {
                if (
                    !document.documentElement.classList.contains(
                        '-is-active-menu'
                    )
                ) {
                    return;
                }
                if (e.target.classList.contains('js-menu-toggle')) {
                    return;
                }
                if (!isElementInsideMenu(menu, e.target)) {
                    closeMenu(menu, toggles, animationDuration);
                }
            });
        });
    }

    /**
     * Attempts to find the toggle that opened the mobile menu; if found, shifts focus to that toggle.
     *
     * @param {*} menu
     */
    function focusOpeningToggle(menu) {
        // console.log('Attempting to focus a toggle that opened the menu...');

        let opener = menu.parentNode.querySelector('.js-menu-toggle.-can-open');
        if (!opener) {
            return;
        }
        opener.focus();
    }

    // Return an object to expose inner functions
    return {
        makeOutsideFocusCloseMenu: makeOutsideFocusCloseMenu,
        focusOpeningToggle: focusOpeningToggle,
        openMenu: openMenu,
        closeMenu: closeMenu,
    };
}

// Store tools in window
window.mobile_menu_tools = mobile_menu_tools();
